export const miniDrawerWidth = 70;
export const drawerWidth = 295;

export const miniDrawerWidthSeller = 70;
export const drawerWidthSeller = 266;
